<template>
  <aside class="sideBar scroller">
    <h1 class="logo"><img src="/static/gaby.svg" alt="Gaby"> Gaby</h1>

    <nav class="navigation">
      <ul class="navigation__list">
        <li class="navigation__item">
          <router-link :to="{ name: 'dashboard' }" class="navigation__link">
            <font-awesome-icon :icon="['fal', 'tachometer-alt']" class="navigation__icon"/> Dashboard
          </router-link>
        </li>
        <li class="navigation__item">
          <button class="navigation__link navigation__link--has-children" :class="{ 'is-active': dropdown }" @click="dropdown = !dropdown">
            <font-awesome-icon :icon="['fal', 'book']" class="navigation__icon"/> Content
          </button>

          <ul class="navigation__dropdown" :class="{ 'is-active': dropdown }">
            <li class="navigation__item">
              <router-link :to="{ name: 'pages.index', params: { typeId: 'all' } }" class="navigation__link navigation__link--dropdown">
               All types
              </router-link>
            </li>
            <li class="navigation__item" v-for="type in types" :key="type.id">
              <router-link :to="{ name: 'pages.index', params: { typeId: type.id } }" class="navigation__link navigation__link--dropdown">
               {{ type.name }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="navigation__item">
          <router-link :to="{ name: 'categories.index' }" class="navigation__link">
            <font-awesome-icon :icon="['fal', 'archive']" class="navigation__icon"/> Categories
          </router-link>
        </li>
        <li class="navigation__item">
          <router-link :to="{ name: 'navigations.index' }" class="navigation__link">
            <font-awesome-icon :icon="['fal', 'bars']" class="navigation__icon"/> Navigations
          </router-link>
        </li>
        <li class="navigation__item">
          <router-link :to="{ name: 'settings' }" class="navigation__link">
            <font-awesome-icon :icon="['fal', 'cog']" class="navigation__icon"/> Settings
          </router-link>
        </li>
        <li class="navigation__item">
          <router-link :to="{ name: 'sliders.index' }" class="navigation__link">
            <font-awesome-icon :icon="['fal', 'images']" class="navigation__icon"/> Sliders
          </router-link>
        </li>
        <li class="navigation__item">
          <router-link :to="{ name: 'screens.index' }" class="navigation__link">
            <font-awesome-icon :icon="['fal', 'tv']" class="navigation__icon"/> TV screens
          </router-link>
        </li>
        <li class="navigation__item">
          <router-link :to="{ name: 'users.index' }" class="navigation__link">
            <font-awesome-icon :icon="['fal', 'users']" class="navigation__icon"/> Users
          </router-link>
        </li>
      </ul>
    </nav>

    <div class="profile">
      <font-awesome-icon :icon="['fal', 'user']" class="profile__icon"/>
      <div class="profile__info">
        <h4 class="profile__heading mt0">{{ $auth.user.name }}</h4>
        <p class="profile__subHeading mt0 mb0" @click="$auth.logout()">Sign out</p>
      </div>
    </div>
  </aside>
</template>

<script>
import * as types from '@/store/types.js'

export default {
  data () {
    return {
      dropdown: false
    }
  },
  computed: {
    types () {
      return this.$store.getters[types.ALL_TYPES]
    }
  },
  mounted () {
    if (this.$route.fullPath.includes('content')) {
      this.dropdown = true
    }
  }
}
</script>

<style lang="stylus">
@import '~stylus-easing'
@import '../assets/stylus/general/_variables'
@import '../assets/stylus/general/_mixins'

.sideBar
  background sideBarColor
  color white
  padding 2rem 0
  display flex
  flex-direction column

.logo
  margin 0 20px 30px
  text-transform lowercase
  font-weight 300

  img
    max-width 30px
    vertical-align middle
    margin-right 10px

.navigation
  margin-bottom auto

  &__list
    padding 0
    margin 0

  &__item
    list-style none

    &:last-child
      border-bottom 1px solid #1f262d

  &__link
    all unset
    color #9CA5BC
    padding 0 20px
    display block
    text-decoration none
    border-top 1px solid #1f262d
    position: relative
    transform: translateZ(0)
    transition: 300ms
    font-weight 300
    font-size rem(16px)
    line-height 60px
    display block
    width 100%
    box-sizing border-box
    cursor pointer

    svg {
      font-size rem(20px)
    }

    &:before
      content: ""
      position: absolute
      z-index: -1
      top: 0
      left: 0
      right: 0
      bottom: 0
      background: activeColor
      transform: scaleX(0)
      transform-origin: 0 50%
      transition-property: transform
      transition: 300ms ease-out

    &.router-link-exact-active, &.router-link-active
      color activeColor

    &:hover
      color white

      &:after
        border-top-color: white

      &:before
        transform: scaleX(1)

    &--dropdown
      padding-left 30px
      background darken(sideBarColor, 30%)
      transition 300ms 100ms
      opacity 0
      line-height 40px

      svg {
        font-size rem(18px)
      }

    &--has-children
      &:after
        content ""
        display block
        border-left 5px solid transparent
        border-right 5px solid transparent
        border-top 5px solid #9CA5BC
        position absolute
        right 20px
        top 50%
        margin-top -2px
        transition 300ms

      &.is-active:after
        transform: rotate(180deg)

  &__icon
    padding-right .8rem

  &__dropdown
    margin 0
    padding 0
    max-height 0px
    overflow hidden
    transition 300ms ease-in-out-quint
    will-change: max-height

    &.is-active
      max-height 500px

      a
        opacity 1

.profile
  display flex
  align-items: center

  &__heading
    margin-bottom 0.3rem
    font-weight 300
    font-size rem(18px)

  &__subHeading
    letter-spacing: 1px
    font-size rem(13px)
    color activeColor
    margin-top -8px

    &:hover
      cursor pointer

  &__icon
    font-size rem(20px)
    margin-right 1rem
    margin-left 20px
    background activeColor
    padding 15px
    border-radius: 50%
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue